module.exports = __webpack_public_path__ + "img/ay.003c9701.jpg";